import { render, staticRenderFns } from "./alarmDialogList.vue?vue&type=template&id=2ab0ddc3&scoped=true&"
import script from "./alarmDialogList.vue?vue&type=script&lang=ts&"
export * from "./alarmDialogList.vue?vue&type=script&lang=ts&"
import style0 from "./alarmDialogList.vue?vue&type=style&index=0&id=2ab0ddc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0ddc3",
  null
  
)

export default component.exports